import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import {
  Box,
  type BoxProps,
  Button,
  Flex,
  type MantineSize,
  Menu,
  NumberInput,
  Text,
} from '@mantine/core'
import { getHotkeyHandler } from '@mantine/hooks'
import { useEffect, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import classes from './styles.module.css'

export type SelectProductQuantityProps = BoxProps & {
  value?: number
  size?: MantineSize
  onChange?: (value: number) => void
  withShortLabel?: boolean
}

export function SelectProductQuantity({
  value,
  onChange,
  size,
  withShortLabel,
  ...props
}: SelectProductQuantityProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  const [menuQtyOpened, setMenuQtyOpened] = useState(false)
  const [quantityToAdd, setQuantityToAdd] = useState(1)
  const [quantityCustomToAdd, setQuantityCustomToAdd] = useState<
    number | undefined
  >(10)
  useEffect(() => {
    if (typeof value === 'number') {
      setQuantityToAdd(value)
    }
  }, [value])

  const handleChange = (value: number) => {
    setQuantityToAdd(value)
    onChange?.(value)
  }

  return (
    <Menu
      withinPortal
      position='bottom-start'
      opened={menuQtyOpened}
      onChange={setMenuQtyOpened}
      {...props}
    >
      <Menu.Target>
        <Flex gap='xs' align='center' style={{ cursor: 'pointer' }}>
          <Text size={size}>
            {withShortLabel
              ? t('select_product_quantity.label_quantity_short')
              : t('select_product_quantity.label_quantity')}
            :
          </Text>
          <Text fw={500} size={size}>
            {quantityToAdd}
          </Text>
          <Icon icon={faAngleDown} size='xs' />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown>
        {Array.from({ length: 5 }, (_, i) => i + 1).map((num) => (
          <Menu.Item key={num} onClick={() => handleChange(num)}>
            {num}
          </Menu.Item>
        ))}
        <Menu.Divider />
        <Menu.Item
          component={Box}
          closeMenuOnClick={false}
          className={classes.custom}
        >
          <Text size='sm' fw={500}>
            {t('select_product_quantity.label_custom_value')}
          </Text>
          <NumberInput
            size='sm'
            value={quantityCustomToAdd}
            onChange={(e) => setQuantityCustomToAdd(Number(e))}
            w={100}
            mt='xs'
            rightSection={<></>}
            rightSectionPointerEvents='none'
            onKeyUp={getHotkeyHandler([
              [
                'Enter',
                () => {
                  handleChange(quantityCustomToAdd ?? 1)
                  setMenuQtyOpened(false)
                },
              ],
            ])}
          />
          <Button
            size='xs'
            h={25}
            px={8}
            className={classes.customButton}
            onClick={() => {
              handleChange(quantityCustomToAdd ?? 1)
              setMenuQtyOpened(false)
            }}
          >
            OK
          </Button>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
